import type { ChatUi } from '@voll-intelligence/genui-contract';
import type { GenUiEntry } from '../../shared/ui/registry.js';
import { ApprovalStackCard } from './ui/approval_stack.js';

/**
 * Entrada de catálogo do `approval_stack` (slot chat). Interativo — os botões
 * per-voucher disparam `approval-decision` (decideChallengeId); os botões de
 * grupo disparam `approval-bulk-decision` (bulkChallengeId/allChallengeId +
 * scope). O card monta o próprio texto; o shell é só transporte. Congela com
 * `readOnly`.
 */
export const approvalStackEntry: GenUiEntry<Extract<ChatUi, { kind: 'approval_stack' }>> = {
  kind: 'approval_stack',
  slot: 'chat',
  policy: {
    // Cada reemissão carrega challenges NOVOS e deve aparecer como card
    // acionável no turno atual — reconciliar por id congelaria o stack novo
    // na linha antiga (challenges já resolvidos).
    reconcileById: false,
  },
  render: ({ ui, note, readOnly, dispatch }) => (
    <ApprovalStackCard
      ui={ui}
      note={note}
      readOnly={readOnly}
      dispatch={readOnly ? undefined : dispatch}
    />
  ),
};
